import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { bulletinsApi } from '../api/bulletins.api';

export function useBulletinsParPeriode(annee: number, mois: number) {
  return useQuery({
    queryKey: ['bulletins', { annee, mois }],
    queryFn: () => bulletinsApi.listerParPeriode(annee, mois),
    enabled: !!annee && !!mois,
  });
}

export function useBulletin(id: string | undefined) {
  return useQuery({
    queryKey: ['bulletin', id],
    queryFn: () => bulletinsApi.obtenirParId(id!),
    enabled: !!id,
  });
}

export function useTableauRemuneration(annee: number, mois: number) {
  return useQuery({
    queryKey: ['tableau-remuneration', { annee, mois }],
    queryFn: () => bulletinsApi.tableau(annee, mois),
    enabled: !!annee && !!mois,
  });
}

export function useJobStatut(jobId: string | null) {
  return useQuery({
    queryKey: ['job', jobId],
    queryFn: () => bulletinsApi.statutJob(jobId!),
    enabled: !!jobId,
    refetchInterval: (data) => {
      if (!data) return 3000;
      return data.statut === 'completed' || data.statut === 'failed' ? false : 3000;
    },
  });
}

export function useCreerBulletin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bulletinsApi.creer,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['bulletins'] }),
  });
}

export function useLancerGenerationMasse() {
  return useMutation({ mutationFn: bulletinsApi.lancerMasse });
}

export function useChangerStatutBulletinsMasse() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ mois, annee, statut }: { mois: number; annee: number; statut: 'VALIDE' | 'PAYE' }) =>
      bulletinsApi.changerStatutMasse(mois, annee, statut),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['bulletins'] });
    },
  });
}

export function useChangerStatutBulletin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ idBulletin, statut }: { idBulletin: string; statut: 'BROUILLON' | 'GENERE' | 'VALIDE' | 'PAYE' }) =>
      bulletinsApi.changerStatut(idBulletin, statut),
    onSuccess: (_data, { idBulletin }) => {
      qc.invalidateQueries({ queryKey: ['bulletins'] });
      qc.invalidateQueries({ queryKey: ['bulletin', idBulletin] });
    },
  });
}

export function useSupprimerBulletin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (idBulletin: string) => bulletinsApi.supprimer(idBulletin),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['bulletins'] }),
  });
}
